import TableTotalsWrapper from 'components/tables/totals/TableTotalsWrapper';
import TotalsLimitAlert from 'components/tables/totals/TotalsLimitAlert';
import MoneyDisplay from 'components/util/MoneyDisplay';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { BankTransactionTotalsDto } from 'types/bank-transfers.ts';

/**
 * Overall totals ribbon for the bank-transfers list: one entry per currency in the filter output,
 * styled like the per-currency totals in each date group's header. Amounts stay in their original
 * currency — bank transfers are never converted to the tenant base currency.
 */
const BankTransfersTotals: FC<BankTransactionTotalsDto & { isLoading: boolean }> = ({
    entryAmountBreakdown,
    limitExceeded,
    isLoading,
}) => {
    if (limitExceeded) {
        return (
            <TableTotalsWrapper isLoading={isLoading}>
                <TotalsLimitAlert>
                    <FormattedMessage id="bank-transfers.totals.limit-exceeded" />
                </TotalsLimitAlert>
            </TableTotalsWrapper>
        );
    }

    return (
        <TableTotalsWrapper isLoading={isLoading}>
            <span className="text-caption text-fg-secondary">
                <FormattedMessage id="bank-transfers.totals.total" />
            </span>
            {entryAmountBreakdown.map(({ currencyTypeCode, amount }) => (
                <div key={currencyTypeCode} className="flex items-center gap-1">
                    <span className="text-caption text-fg-secondary font-semibold">{currencyTypeCode}:</span>
                    <span className="text-subtitle2 font-semibold">
                        <MoneyDisplay amount={amount} />
                    </span>
                </div>
            ))}
        </TableTotalsWrapper>
    );
};

export default BankTransfersTotals;
